// extracted by mini-css-extract-plugin
export default {"element":"burger-empty-element_element__61CIn"};